import { render } from "./btn-flow-light-one.vue?vue&type=template&id=201995a1&scoped=true"
import script from "./btn-flow-light-one.vue?vue&type=script&lang=js"
export * from "./btn-flow-light-one.vue?vue&type=script&lang=js"

import "./btn-flow-light-one.vue?vue&type=style&index=0&id=201995a1&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-201995a1"

export default script